// extracted by mini-css-extract-plugin
module.exports = {"selection":"HotelDetails_selection__1E27e"};